// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderResultSearchBase } from './pharmacyCardFinderResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyCardFinderResultSearchResponse {
    'results'?: Array<PharmacyCardFinderResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyCardFinderResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<PharmacyCardFinderResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyCardFinderResultSearchResponse.attributeTypeMap;
    }
}
